import "../../../../js/molecules/fields/copyToClipboardField";
import "../../../../js/atoms/toggle/translate-contents";
import "../../../../js/utils/waitVote";
import { Application } from "@hotwired/stimulus";
import TranslationController from "../../../../js/controllers/translation_controller";

// Initialize existing functionality
Domestika.contentTranslate.init();

// Register the translation controller
const application = Application.start();
application.register("translation", TranslationController);
